export const ANSWER_NUMVER_MAP = ['①', '②', '③', '④', '⑤']
